export default __webpack_public_path__ + "static/media/avatar_elephant6.9c91481d.mp3";